import {MergeAccountInfo} from "./useMergeAccount";

const emailKey = "wakelet-link-account-email"
const mergeAccountKey = "wakelet-merge-account";
export const LinkAccountStore = {
  set(accountInfo: MergeAccountInfo): void {
    sessionStorage.setItem(mergeAccountKey, JSON.stringify(accountInfo));
  },
  get(): MergeAccountInfo {
    const value = sessionStorage.getItem(mergeAccountKey);
    if (!value) {
      return {};
    }
    try {
      return JSON.parse(value) as MergeAccountInfo;
    } catch (err) {
      console.error("unable to parse merge account info", err);
      return {};
    }
  },
  getEmail(): string | null {
    return sessionStorage.getItem(emailKey)
  },
  setEmail(email: string) {
    sessionStorage.setItem(emailKey, email)
  },

  clear() {
    sessionStorage.removeItem(emailKey)
    sessionStorage.removeItem(mergeAccountKey);
  }
}